/* @flow */
import Collection from 'lib/Collection';
import GroupClusterItem from 'entities/GroupClusterItem';

export default class GroupClusterItems extends Collection<GroupClusterItem> {
  initialize() {
    this.model = GroupClusterItem;
  }
}
